import { IUserProfile, UpdateUserProfile } from "@/types/breeze/UserProfile";
import { BaseService } from "../BaseService";

export class UserProfileService extends BaseService {
  public async getByUser(userId: number): Promise<IUserProfile> {
    return this.getRequest(`/user-profiles/by-user/${userId}`);
  }

  public async updateByUser(
    userId: number,
    patch: UpdateUserProfile,
  ): Promise<IUserProfile> {
    return this.putRequest(
      `/user-profiles/by-user/${userId}`,
      patch,
      "Profile updated",
    );
  }
}

export const userProfileService = new UserProfileService();
